import { fragranceProfilerRepository } from "../../repository/FragranceProfilerRepository";
import { ProfilerAnswers } from "../../stores/useProfilerStore";
import { FragranceProfilerResults } from "../../types/FragranceProfilerResults";

export const computeFragranceProfilerResults = (
  profiler: string | null,
  answers: ProfilerAnswers,
  isReady: boolean
): FragranceProfilerResults | null => {
  if (!isValidProfilerRequest(profiler, isReady, answers)) {
    return null;
  }

  try {
    const results = computeResults(answers);
    if (!results) {
      console.error(
        "Failed to compute fragrance profiler results - missing required data"
      );
      return null;
    }
    logResults(results);
    return results;
  } catch (error) {
    console.error("Error computing fragrance profiler results:", error);
    return null;
  }
};

const isValidProfilerRequest = (
  profiler: string | null,
  isReady: boolean,
  answers: ProfilerAnswers
): boolean => {
  return profiler === "fragrance-profiler" && isReady && answers.size > 0;
};

const computeResults = (
  answers: ProfilerAnswers
): FragranceProfilerResults | null => {
  const answerOptionIds = Array.from(answers.values());
  const fragranceProfilerResults =
    fragranceProfilerRepository.getResultsByAnswerOptionIds(answerOptionIds);
  return fragranceProfilerResults;
};

const logResults = (results: FragranceProfilerResults): void => {
  if (process.env.NODE_ENV === "development") {
    console.log("Fragrance Profiler Results:");
    console.log("- Fetiche fragrance:", results.feticheFragrance.label);
    console.log("- Opulence fragrance:", results.opulenceFragrance.label);
    console.log("- Sensuality fragrance:", results.sensualityFragrance.label);
    console.log("- Mystery fragrance:", results.mysteryFragrance.label);
    console.log("- Elegance fragrance:", results.eleganceFragrance.label);
    console.log(
      "- Also like fetiche fragrance:",
      results.alsoLikeFeticheFragrance.label
    );
    console.log(
      "- Also like loubiworld fragrance:",
      results.alsoLikeLoubiworldFragrance.label
    );
  }
};
